"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const change_1 = require("../change");
const selection_1 = require("../selection");
function onSelectionChange(editorState) {
    const result = selection_1.getDomRange(editorState.list);
    if (result != null) {
        const { start, end } = result;
        return change_1.updateSelection(editorState, {
            anchorOffset: start,
            focusOffset: end
        });
    }
}
exports.default = onSelectionChange;
//# sourceMappingURL=onSelectionChange.js.map